import { Show, createSignal } from "solid-js";
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetFooter,
  SheetTitle,
  SheetTrigger
} from "@/components/shadcn/sheet";
import {
  Button,
} from "@/components/shadcn/button";
import { Icon } from "@iconify-icon/solid";
import { DateInput } from "../../components/ui/form/DateInput";
import { SelectInput } from "../../components/ui/form/SelectInput";
import { TextInput } from "../../components/ui/form/TextInput";
import { NumberInput } from "../../components/ui/form/NumberInput";
import useAppointment from "../../services/useAppointment";
import { LoadingButton } from "../../components/ui/Button";

export const NewAppointment = (props) => {

  const [open, setOpen] = createSignal(false);

  const onSaved = () => {
    setOpen(false);
    props.onSaved?.();
  };

  const {
      form,
      genders,
      types,
      entries,
      patients,
      statuses,
      showAssociate,
      handleInput,
      handleSave,
      loading,
      fetching,
    } = useAppointment({ onSaved });

  return (
    <Sheet open={open()} onOpenChange={setOpen}>
      <SheetTrigger as={(innerProps) => (<Button variant="outline" {...innerProps} />)}>
        <Icon icon="stash:plus-solid" class="me-2" />
        New Appointment
      </SheetTrigger>
      <SheetContent class="w-full sm:w-3/4 md:max-w-[600px]">
        <SheetHeader>
          <SheetTitle>New Appointment</SheetTitle>
        </SheetHeader>
        <div class="grid grid-cols-4 gap-4 py-4">
          <div class="col-span-2">
            <DateInput
              label="Date"
              name="date"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <SelectInput
              label="New Patient?"
              name="newPatient"
              form={form}
              options={entries()}
              input={handleInput}
            />
          </div>
          <Show when={!form.newPatient}>
          <div class="col-span-4">
            <SelectInput
              label="Patient"
              name="patientId"
              form={form}
              options={patients()}
              input={handleInput}
            />
          </div>
          </Show>
          <Show when={form.newPatient}>
          <div class="col-span-4">
            <TextInput
              label="Patient"
              name="name"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <SelectInput
              label="Gender"
              name="gender"
              form={form}
              options={genders()}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <DateInput
              label="Birth Date"
              name="birthDate"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <SelectInput
              label="Type"
              name="type"
              form={form}
              options={types()}
              input={handleInput}
            />
          </div>
          <Show when={showAssociate()}>
            <div class="col-span-4">
              <TextInput
                label="Associate Person"
                name="associateName"
                form={form}
                input={handleInput}
              />
            </div>
          </Show>
          <div class="col-span-2">
            <TextInput
              label="Cnic"
              name="cnic"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <TextInput
              label="Phone"
              name="phone"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <TextInput
              label="Email"
              name="email"
              form={form}
              input={handleInput}
            />
          </div>
          </Show>
          <div class="col-span-2">
            <NumberInput
              label="Fees"
              name="fees"
              form={form}
              input={handleInput}
            />
          </div>
          <div class="col-span-2">
            <SelectInput
              label="Payment"
              name="status"
              form={form}
              options={statuses()}
              input={handleInput}
            />
          </div>
        </div>
        <SheetFooter>
					<LoadingButton onClick={(e) => { handleSave(e) }} type="button" loading={loading()} disabled={fetching()}>Add appointment</LoadingButton>
				</SheetFooter>
      </SheetContent>
    </Sheet>
  );
}
